import { useMutation, useQueryClient } from '@tanstack/react-query'
import notificationService from '../../service'
import { notificationQueryKeys } from '../keys/notification.query-keys'

export const useDeleteAllNotifications = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: notificationService.removeAllMine,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationQueryKeys.all }),
  })
}
